"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var react_intl_1 = require("react-intl");
var AboutUSLayout = function () {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.Container, { maxWidth: "md", style: { height: '50vh' } },
            react_1.default.createElement(core_1.Typography, null,
                " ",
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "aboutContent" })))));
};
exports.default = AboutUSLayout;
